import PropTypes from "prop-types";
import React, { useState } from "react";
import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";

const NewUserModal = (props) => {
  const { users, setUsers, setNewUserModal } = props;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState("");

  const postUser = async () => {
    const response = await fetch("/users_management", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        user: {
          first_name: firstName,
          last_name: lastName,
          email: email,
        },
      }),
    });
    if (response.ok) {
      const data = await response.json();
      setUsers([...users, ...[data.user]]);
      setNewUserModal(false);
    } else {
      console.log("error");
    }
  };

  const onClose = () => {
    setNewUserModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validation = validateAttributes(
      {
        firstName,
        lastName,
        email,
      },
      validations,
    );

    setErrors(validation);

    if (validation) return;
    postUser();
  };

  const className = (attribute) => {
    let className = "flex-1 bg-gray-100 px-3 py-2";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white shadow-lg p-6 w-full max-w-lg relative space-y-6">
        <h1 className="font-bold">Dodaj Usera</h1>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-black"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Imię
            </span>
            <input
              className={className("firstName")}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="flex gap-4">{errorMessage(errors, "firstName")}</div>

          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Nazwisko
            </span>
            <input
              className={className("lastName")}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="flex gap-4">{errorMessage(errors, "lastName")}</div>

          <div className="flex gap-4">
            <span className="w-48 text-gray-500 flex items-center gap-1">
              Email
            </span>
            <input
              className={className("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="flex gap-4">{errorMessage(errors, "email")}</div>

          <button
            type="submit"
            className="flex items-center gap-2 bg-black text-white px-4 py-2"
          >
            Zapisz
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewUserModal;

NewUserModal.propTypes = {
  users: PropTypes.array,
  setUsers: PropTypes.func,
  setNewUserModal: PropTypes.func,
};
